import React from 'react'
import { MdClose } from 'react-icons/md'

import dimensions from 'shared/styles/dimensions'
import intersect from 'shared/assets/images/intersect.png'

import { colors } from '../../styles/colors'
import Button from '../Button'
import {
  Container,
  ContentContainer,
  ContainerHeader,
  ContainerDetail,
  Title,
  ContainerButton,
} from './styles'

interface IModalProps {
  id?: string
  openModal: boolean
  'aria-label'?: string
  showCloseButton?: boolean
  size?: 'small' | 'medium' | 'large' | 'unset'
  onCloseModal?(): void
  curvature?: boolean
  margin?: string
  title?: string
  showCloseButtonBottom?: boolean
  overflowY?: 'visible' | 'hidden' | 'clip' | 'scroll' | 'auto'
}

const Modal: React.FC<IModalProps> = ({
  id,
  openModal,
  onCloseModal,
  showCloseButton = true,
  size = 'medium',
  children,
  curvature = false,
  margin,
  title,
  showCloseButtonBottom = false,
  overflowY,
  ...props
}) => {
  return (
    <Container id={id} openModal={openModal} {...props}>
      <ContentContainer
        $size={size}
        $curvature={curvature ? intersect : undefined}
        $margin={margin}
      >
        <ContainerHeader showCloseButtonBottom={showCloseButtonBottom}>
          {title && <Title>{title}</Title>}
          {showCloseButton && (
            <Button transparent={true} size="small" onClick={onCloseModal}>
              <MdClose color={colors.blue} size={dimensions.medium} />
            </Button>
          )}
        </ContainerHeader>
        <ContainerDetail overflowY={overflowY}>{children}</ContainerDetail>
        {showCloseButtonBottom && (
          <ContainerButton>
            <Button color={colors.green} size="large" onClick={onCloseModal}>
              Fechar
            </Button>
          </ContainerButton>
        )}
      </ContentContainer>
    </Container>
  )
}

export default Modal
